export default {
	Store: [
		// {
		// 	action: "zmdi-ticket-star",
		// 	title: "message.bots",
		// 	// active: false,
		// 	label: "Old",
		// 	path: "/ticket-bot",
		// 	exact: true,
		// },
		// {
		// 	action: "zmdi-view-dashboard",
		// 	title: "message.events",
		// 	// active: true,
		// 	label: "Old",
		// 	path: "/events",
		// 	exact: true,
		// },
		{
			action: "zmdi-accounts",
			title: "message.clients",
			// active: false,
			label: "Old",
			path: "/ticket-user",
			exact: true,
		},
		{
			action: "zmdi-shopping-cart",
			title: "message.sales",
			// active: false,
			label: "Old",
			exact: true,
			items: [
				{
					title: "Pendientes",
					path: "/ticket-sales/pending",
					exact: true,
				},
				{
					title: "Verificadas",
					path: "/ticket-sales/verified",
					exact: true,
				},
				// {
				// 	title: "Por verificar",
				// 	path: "/ticket-sales/notVerified",
				// 	exact: true,
				// },
				{
					title: "Canceladas",
					path: "/ticket-sales/rejected",
					exact: true,
				},
				// {
				// 	title: "Todas",
				// 	path: "/ticket-sales/all",
				// 	exact: true,
				// },
			],
		},
		{
			action: "zmdi-pin-account",
			title: "message.accounts",
			// active: true,
			label: "Old",
			path: "/ticket-accounts",
			exact: true,
		},
		// {
		// 	action: "zmdi-pin-help",
		// 	title: "message.ticketFaqs",
		// 	// active: true,
		// 	label: "Old",
		// 	path: "/faq",
		// 	exact: true,
		// },
	],
};
